import {Component, Input, OnInit} from '@angular/core';
import {EFormHelper} from '../../../helper/script/helper';
import {FormGroup, ValidatorFn} from '@angular/forms';
import {State} from '../../../model/eform-type';
import {ErorsMessage} from '../../../helper/script/error-message';
import {TranslateService} from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
   selector: 'app-table-properties',
   templateUrl: './table-properties.component.html',
   styleUrls: ['./table-properties.component.scss']
})
export class TablePropertiesComponent implements OnInit {
   @Input() eForm: FormGroup;
   @Input() state: State;
   helper = new EFormHelper();
   errMsg = new ErorsMessage(this.translate);
   displayDisabled: boolean;
   @Input() eventsStateChild: Observable<void>;

   constructor(public translate: TranslateService) {
   }

   ngOnInit(): void {
      this.setValidateItem();
      this.helper.checkDisplayDisabled(this.eForm, this.state);
      this.helper.displayDisabledChanges.subscribe((value) => {
         this.displayDisabled = value;
      });
      if (this.eventsStateChild) {
         this.eventsStateChild.subscribe(() => {
            this.helper.checkDisplayDisabled(this.eForm, this.state);
         });
      }
   }

   updateNumber(type: string, value: number) {
      this.getTable.get(type).patchValue((!value) ? '' : Number(value));
      this.setValidateItem();

   }

   setValidateItem() {
      setTimeout(() => {
         this.getTable.get('minItem').updateValueAndValidity();
         this.getTable.get('maxItem').updateValueAndValidity();
      }, 500);
   }

   get getTable() {
      return this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex);
   }

   range(min: number, max: number): ValidatorFn {
      return (): { [key: string]: boolean } | null => {
         if (!max && max !== 0) {
            return null;
         }
         if (max < min) {
            return {'range': true};
         }
         return null;
      };
   }

}
